import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const MotherAge = () => {
    const { chartData } = useParentsInfoChartsDataContext();


    return (
        <SimpleBars
            title={'Idade da Mãe'}
            horizontal={false}
            subtitles={chartData?.motherAge?.map((item) => item.description)}
            values={chartData?.motherAge?.map((item) => item.total  ||  0)}
        />
    );
};
